// The MILO staff APIs (BM-9711 list, BM-9712 history). Charts still come from miloMockApi.js
// until a metrics API exists.
import { AppConfiguration } from "config"
import { genericGetRequest_2 } from "helpers/sf_backend_helper"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { MILO_PAGE_SIZE, MILO_STATUSES } from "./milo_helper"

const BASE_PATH = "/api/v1/admin/pricing_advisor/campaigns"

export const MILO_LOAD_ERROR = "Could not load MILO data. Please try again."

// genericGetRequest_2 throws plain strings, and these endpoints answer a bad filter (400) or an
// unknown campaign (404) with a bare { error } that it passes through as a success. Both become an
// Error, so callers can always show e.message.
const getMilo = async (path, params) => {
    let body
    try {
        body = await genericGetRequest_2(
            `${AppConfiguration.BACKEND_URL}${BASE_PATH}${path}`,
            params,
            { Authorization: bsh_getAdminUserDetails()?.token || "" },
        )
    } catch (e) {
        throw new Error(MILO_LOAD_ERROR)
    }
    if (!body || body.error) throw new Error(body?.error || MILO_LOAD_ERROR)
    return body
}

// GET /api/v1/admin/pricing_advisor/campaigns
export const fetchMiloCampaigns = ({
    page_number = 1,
    page_size = MILO_PAGE_SIZE,
    sort_column,
    sort_direction,
    status,
    reason_code,
    behind_pace,
    account_id,
} = {}) => getMilo("", {
    page_number,
    page_size,
    sort_column,
    sort_direction,
    // The API filters on its own labels ("Raise", "No recommendation"), not the page's keys.
    status: status ? MILO_STATUSES[status]?.label : undefined,
    reason_code: reason_code || undefined,
    // Only send behind_pace when the switch is on: the API reads "false" as "on pace only".
    behind_pace: behind_pace ? "true" : undefined,
    account_id: String(account_id || "").trim() || undefined,
})

// GET /api/v1/admin/pricing_advisor/campaigns/:id/history
// Newest check first, 50 checks per page, covering today and the 6 days before (PST).
export const fetchMiloCampaignHistory = (campaignId, page_number = 1) => (
    getMilo(`/${encodeURIComponent(campaignId)}/history`, { page_number })
)
